import Pqp from "../../../3x1010/Pqp.js";
import Game from "../../Game.js";
import Spike from "../../screen/tileAnimation/Spike.js";
import TileAnimation from "../../screen/tileAnimation/TileAnimation.js";
import Torch from "../../screen/tileAnimation/Torch.js";
import TileMap from "../../screen/tilemap/TileMap.js";
import Maze from "../Maze.js";

export default class CellRender {
	constructor(cell, model, sp) {
		this.cell = cell;
		this.model = model;
		this.sp = sp;
	}

	init() {
		if (!this.cell.hasTiles()) {
			this.createBaseTile();
			this.createHigherTile();
			if (this.model.hasFov()) {
				if (this.cell.tiles.length === 1) {
					this.cell.tiles.push(null);
				}
				this.createFovTile();
				for (let x = 0; x < 2; x++) {
					if (this.cell.tiles[x]) {
						this.cell.tiles[x].css("opacity", 0);
					}
				}

			}
		}
	}

	createBaseTile() {
		let tile = this.createTile();
		this.createBackground();
		this.createDoor();
		this.createStartEnd();
		this.createTorch();
		if (this.cell.isSpike()) {
			this.createSpike();
		}
		this.createFurniture();
	}


	createTile() {
		let tile = jQuery("#template-maze-tile").clone();
		/*let z = this.cell.row * 2 * this.cell.model.cols + this.cell.col
		if (!this.cell.isWall()) {
			z = 1;
		}*/
		tile.attr("id", "mati" + CellRender.ENUM++);
		tile.attr("data-ref", this.cell.row + "|" + this.cell.col);
		tile.css(
			{
				//"z-index": z,
				"width": Game.TILE_WIDTH_MAP,
				"height": Game.TILE_HEIGHT_MAP
			});
		this.cell.tiles.push(tile);
		this.updateZindex(tile);

		return tile;
	}

	updateZindex(tile) {
		//let z = this.cell.row * 2 * this.cell.model.cols + this.cell.col
		//let z = this.cell.row * 10 * this.cell.model.cols + this.cell.col
		let z = this.cell.row * 2 * this.cell.model.cols + this.cell.col
		if (this.cell.canWalk()) {
			z = 1;
		}
		if (this.cell.isColumn()) {
			z = 1;
		}
		if (this.cell.isFireplace()) {
			z = 1;
		}
		if (  (this.cell.furniture) && (!this.cell.isWall()) )  {
			z = 1;
		}

		tile.css(
			{
				"z-index": z,
			});
	}

	createFovTile() {
		let tile = jQuery("#template-maze-tile-fov").clone();
		let z = this.cell.row * 2 * this.cell.model.cols + this.cell.col
		/*if (!this.cell.isWall()) {
			z = 1;
		}
		tile.attr("id", "mati" + CellRender.ENUM++);
		tile.attr("data-ref", this.cell.row + "|" + this.cell.col);*/
		tile.css(
			{
				//"z-index": z,
				"width": Game.TILE_WIDTH_MAP,
				"height": Game.TILE_HEIGHT_MAP
			});
		this.cell.tiles.push(tile);
		this.updateZindex(tile);

		return tile;
	}


	createBackground() {

		if (this.cell.isWall()) {
			this.createWall();

		} else {
			this.createWalkable();

		}
	}

	createWalkable() {
		let cell = this.cell;
		// Pavimento walkabile
		let sprite = null;
		let lNormalFloor = true;
		if (cell.isRoom()) {
			// Pavimento di una room (non hallway)
			let room = this.model.getRoomById(cell.room);
			if (!room.isHallway()) {
				if (room.paving === -1) {
					room.paving = this.nextPaving();
				}
				sprite = this.sp.getPaving(room.paving, cell.rowRoom, cell.colRoom);
				lNormalFloor = false;
			}
		}
		if (lNormalFloor) {
			// pavimento a caso
			sprite = this.sp.getFloor();
		}

		if (sprite) {
			this.drawSprite(0, CellRender.LEVEL_BACKGROUND, sprite);
		}
	}

	nextPaving() {
		let pavings = TileMap.STYLER.kit.paving;
		if (CellRender.NEXT_PAVING >= pavings.length) {
			CellRender.NEXT_PAVING = -1;
		}

		// Definisce il prossimo set di pavimento delle stanze tra quelli disponibili
		if (CellRender.NEXT_PAVING === -1) {
			CellRender.NEXT_PAVING = Pqp.rnd(pavings.length - 1);
			//console.log(CellRender.NEXT_PAVING)
		}
		CellRender.NEXT_PAVING++;
		if (CellRender.NEXT_PAVING === pavings.length) {
			CellRender.NEXT_PAVING = 0;
		}
		return CellRender.NEXT_PAVING;
	}

	removeSprite(tileIndex, target) {
		let cell = this.cell;
		jQuery(target, cell.tiles[tileIndex]).css("background-image", "none");
	}

	drawSprite(tileIndex, target, sprite, lFlipH = false, lFlipV = false, rotate = 0, opacity = 1) {
		let cell = this.cell;
		jQuery(target, cell.tiles[tileIndex]).css("background-image", "url('" + sprite + "')");
		if (target === CellRender.LEVEL_STAND) {
			jQuery(target, cell.tiles[tileIndex]).css("display", "block");
		}
		if (lFlipH && lFlipV) {
			if (rotate !== 0) {
				jQuery(target, cell.tiles[tileIndex]).addClass("maze-tile-flip-wh-rotate-" + rotate);
			} else {
				jQuery(target, cell.tiles[tileIndex]).addClass("maze-tile-flip-wh");
			}

		} else if (lFlipH) {
			if (rotate !== 0) {
				jQuery(target, cell.tiles[tileIndex]).addClass("maze-tile-flip-w-rotate-" + rotate);
			} else {
				jQuery(target, cell.tiles[tileIndex]).addClass("maze-tile-flip-w");
			}
		} else if (lFlipV) {
			if (rotate !== 0) {
				jQuery(target, cell.tiles[tileIndex]).addClass("maze-tile-flip-h-rotate-" + rotate);
			} else {
				jQuery(target, cell.tiles[tileIndex]).addClass("maze-tile-flip-h");
			}
		} else {
			if (rotate !== 0) {
				jQuery(target, cell.tiles[tileIndex]).addClass("maze-tile-rotate-" + rotate);
			}
		}

		if (opacity !== 1) {
			jQuery(target, cell.tiles[tileIndex]).css("opacity", opacity);
		}

	}

	createWall() {
		let cell = this.cell;
		let sprite = null;
		// Muro accordingly al pattern
		let pattern = this.model.getWallPattern(cell);
		sprite = this.sp.getWall(pattern)
		// Controlla se ha una porta a sud
		let s = this.model.getNearbyCell(cell, Maze.DIR_S);
		/*if (s) {
			if (s.isDoor()) {
				// Aggiunge il pezzo della porta a sè 
				let piece = this.sp.getDoorPiece();
				this.drawSprite(0, CellRender.LEVEL_STAND, piece);
			}
		}*/
		// Controlla se ha un'entrata/uscita a sud
		if (s) {
			//if ((s.start) || (s.end)) {
			if ((s.start)) {
				let piece = this.sp.getEntrancePiece();
				let lFlipH = false;
				if (s.col === 0) {
					lFlipH = true;
				}
				this.drawSprite(0, CellRender.LEVEL_STAND, piece, lFlipH);
			}
		}
		// Controlla se ha una porta orizzontale a sx o dx
		let altWall = -1;
		let e = this.model.getNearbyCell(cell, Maze.DIR_E);
		if (e) {
			if (e.isHorizontalDoor()) {
				altWall = 0;
			}
		}
		let w = this.model.getNearbyCell(cell, Maze.DIR_W);
		if (w) {
			if (w.isHorizontalDoor()) {
				altWall = 1;
			}
		}
		// Controlla quindi se il muro è di quelli orizzontali senza altri incastri e lo sostituisce
		if (altWall !== -1) {
			if ((pattern === "0001") || (pattern === "0100")) {
				sprite = this.sp.getWallArch(altWall);
			}
		}
		if (sprite) {
			this.drawSprite(0, CellRender.LEVEL_BACKGROUND, sprite);
		}

	}

	createFurniture() {
		let cell = this.cell;
		//console.log(cell.furniture)
		if (this.cell.tiles.length === 1) {
			this.createTile();
		}

		if (!Pqp.isNullOrEmpty(cell.furniture)) {
			if (cell.furnitureUpper) {
				this.drawSprite(1, CellRender.LEVEL_STAND, cell.furniture);
			} else {
				this.drawSprite(0, CellRender.LEVEL_STAND, cell.furniture);
			}
		}

	}

	createTorch() {

		let cell = this.cell;
		let torches = this.model.torches;
		for (let x = 0; x < torches.length; x++) {
			if (torches[x].id === cell.id) {
				cell.torch = true;
				let anim = new Torch(this.sp, cell, cell.tiles[0], CellRender.LEVEL_STAND);
				anim.init("unlit");
				cell.animatedTiles.push(anim);
				// Aggiusta anche il wall
				this.createTorchWall(cell);
				break;
			}
		}

		/*
		if (cell.isWall()) {
			let s = this.model.getNearbyCell(cell, Maze.DIR_S);
			if (s) {
				if (s.isDeadEnd()) {
					cell.torch = true;
					let anim = new Torch(this.sp, cell, cell.tiles[0], CellRender.LEVEL_STAND);
					anim.init("unlit");
					cell.animatedTiles.push(anim);
					// Aggiusta anche il wall
					this.createTorchWall(cell);

				}
			}
		}*/
	}

	createTorchWall(cell) {
		let sprite = this.sp.getTorchWall(cell.isTorchLit());
		this.drawSprite(0, CellRender.LEVEL_BACKGROUND, sprite);
	}



	createDoor() {
		let cell = this.cell;
		if (cell.isDoor()) {
			let pattern = this.model.getWallPattern(cell);
			let sprite = this.sp.getDoor(pattern);
			this.drawSprite(0, CellRender.LEVEL_STAND, sprite);
		}
	}

	createStartEnd() {
		let cell = this.cell;
		if ((cell.start) || (cell.end)) {
			let lFlipH = false;
			let lFlipV = false;
			let rotate = 0;
			let dir;
			let sprite;

			if (cell.start) {
				if (cell.row === this.model.rows - 1) {
					dir = Maze.DIR_S;
				}
				if (cell.row === 0) {
					dir = Maze.DIR_N;
				}
				if (cell.col === 0) {
					dir = Maze.DIR_W;
					lFlipH = true;
				}
				if (cell.col === this.model.cols - 1) {
					dir = Maze.DIR_E;
				}
				sprite = this.sp.getEntrance(dir);
			} else {
				if (cell.row === this.model.rows - 1) {
					dir = Maze.DIR_S;
					lFlipV = true;
					lFlipH = true;
					rotate = 90;
				}
				if (cell.row === 0) {
					dir = Maze.DIR_N;
					//lFlipV = true;
					lFlipH = true;
					rotate = 90;
				}
				if (cell.col === 0) {
					dir = Maze.DIR_W;
				}
				if (cell.col === this.model.cols - 1) {
					dir = Maze.DIR_E;
					lFlipH = true;
				}
				sprite = this.sp.getExit(dir);
			}

			if (sprite) {
				this.drawSprite(0, CellRender.LEVEL_STAND, sprite, lFlipH, lFlipV, rotate);
			}
		}
	}


	createHigherTile() {
		let cell = this.cell;
		let sprites = new Array();
		let tmp = this.checkIfArch();
		if (tmp) {
			sprites.push(tmp);
		}
		/*tmp = this.checkIfColumn();
		if (tmp) {
			sprites.push(tmp);
		}*/
		tmp = this.checkIfSecretDoorEntrance();
		if (tmp) {
			sprites.push(tmp);
		}

		//console.log(sprites.length)
		if (sprites.length > 0) {
			let tile = this.createTile();
			//debugger
			//console.log(tile)
			for (let x = 0; x < sprites.length; x++) {
				let o = sprites[x];
				this.drawSprite(1, o.level, o.sprite, false, false, o.opacity);
			}
		}

	}

	checkIfArch() {
		// aggiunge l'arco solo per le porte orizzontali (nel range)
		let cell = this.cell;
		let pattern = 0;
		let lCreate = false;

		if (cell.isHorizontalDoor()) {
			pattern = 4;
			lCreate = true;
		}

		if (!lCreate) {
			let e = this.model.getNearbyCell(cell, Maze.DIR_E);
			if (e) {
				if (e.isHorizontalDoor()) {
					pattern = 3;
					lCreate = true;
				}
			}
		}
		if (!lCreate) {
			let se = this.model.getNearbyCell(cell, Maze.DIR_SE);
			if (se) {
				if (se.isHorizontalDoor()) {
					pattern = 0;
					lCreate = true;
				}
			}
		}

		if (!lCreate) {
			let s = this.model.getNearbyCell(cell, Maze.DIR_S);
			if (s) {
				if (s.isHorizontalDoor()) {
					pattern = 1;
					lCreate = true;
				}
			}
		}


		if (!lCreate) {
			let sw = this.model.getNearbyCell(cell, Maze.DIR_SW);
			if (sw) {
				if (sw.isHorizontalDoor()) {
					pattern = 2;
					lCreate = true;
				}
			}
		}


		if (!lCreate) {
			let w = this.model.getNearbyCell(cell, Maze.DIR_W);
			if (w) {
				if (w.isHorizontalDoor()) {
					pattern = 5;
					lCreate = true;
				}
			}
		}

		if (lCreate) {
			let sprite = this.sp.getArch(pattern);
			return { sprite: sprite, level: CellRender.LEVEL_STAND, opacity: 1 };
		}
		return null;
	}

	/*
	checkIfColumn() {
		let cell = this.cell;
		if (cell.isColumn()) {
			let sprite = this.sp.getColumn(1, cell.column);
			if (sprite) {
				return { sprite: sprite, level: CellRender.LEVEL_BACKGROUND, opacity: 1 };
			}
		}
		
		let s = this.model.getNearbyCell(cell, Maze.DIR_S);
		if (s) {
			if (s.isColumn()) {
				let sprite = this.sp.getColumn(0, s.column);
				return { sprite: sprite, level: CellRender.LEVEL_STAND, opacity: 1 };
			}
		}
		return null;
	}*/

	checkIfSecretDoorEntrance() {
		let cell = this.cell;
		/*if (cell.isSecretExit()) {
			let pattern = this.model.getWallPattern(cell);
			let sprite = this.sp.getWall(pattern)
			return { sprite: sprite, level: CellRender.LEVEL_STAND, opacity: CellRender.OPACITY_SECRET_WALLS };
		}*/
		/*
		let s = this.model.getNearbyCell(cell, Maze.DIR_S);
		if (s) {
			if (s.isSecretExit()) {
				if (!s.isHorizontalSecretExit()) {
					let pattern = this.model.getWallPattern(s);
					let sprite = this.sp.getWall(pattern)
					return { sprite: sprite, level: CellRender.LEVEL_STAND, opacity: CellRender.OPACITY_SECRET_WALLS };
				}
			}
		}*/

		return null;
	}


	// Animazioni varie della tile
	openDoor() {
		/*let cell = this.cell;
		let sprite
		if (!cell.isHorizontalDoor()) {
			sprite = this.sp.getSprite("door1", 1, 0);
		} else {
			sprite = this.sp.getSprite("door0", 1, 0);
		}
		this.drawSprite(0, CellRender.LEVEL_STAND, sprite);
		
		if (!cell.isHorizontalDoor()) {
			let n = this.model.getNearbyCell(cell, Maze.DIR_N);
			if (n) {
				if (n.tiles[0]) {
					this.hideSprite(n, 0, CellRender.LEVEL_STAND);
				}
			}
		}*/
	}

	closeDoor() {
		/*let cell = this.cell;
		let sprite
		if (!cell.isHorizontalDoor()) {
			sprite = this.sp.getSprite("door1", 1, 1);
		} else {
			sprite = this.sp.getSprite("door0", 0, 0);
		}
		this.drawSprite(0, CellRender.LEVEL_STAND, sprite);
		
		let n = this.model.getNearbyCell(cell, Maze.DIR_N);
		if (n) {
			if (n.tiles[0]) {
				this.showSprite(n, 0, CellRender.LEVEL_STAND);
			}
		}*/

	}

	showSprite(cell, tileIndex, target) {
		jQuery(target, cell.tiles[tileIndex]).css("display", "block");
	}

	hideSprite(cell, tileIndex, target) {
		jQuery(target, cell.tiles[tileIndex]).css("display", "none");
	}

	dropBuilder(cell) {
		let sprite = this.sp.getSprite("enterexit", 1, 2);
		this.drawSprite(0, CellRender.LEVEL_STAND, sprite);
		this.updateZindex(cell.tiles[0]);
		if ((cell.col === 0) || (cell.col === this.model.cols - 1)) {
			let n = this.model.getNearbyCell(cell, Maze.DIR_N);
			if (n) {
				n.removeSprite(0, CellRender.LEVEL_STAND);
			}
		}
	}


	createSpike() {
		let anim = new Spike(this.sp, this.cell, this.cell.tiles[0], CellRender.LEVEL_STAND);
		anim.init("off");
		this.cell.animatedTiles.push(anim);
		anim.initSpikes();
		//console.log(this.cell.spikeKind)

	}

}

CellRender.ENUM = 0;

CellRender.NEXT_PAVING = -1

CellRender.LEVEL_BACKGROUND = ".js-background";
CellRender.LEVEL_STAND = ".js-other";

CellRender.OPACITY_SECRET_WALLS = 0.5;